import { useState } from 'react'

import { Footer, NavigationBar } from '@percent/cause-dashboard/common/components'
import { ClaimSearchHeader } from './ClaimSearchHeader/ClaimSearchHeader'
import { ClaimSearchResults } from './ClaimSearchResults/ClaimSearchResults'
import styles from './ClaimPage.module.scss'
import { defaultCountryCode } from '@percent/cause-dashboard/constants/countryData'
import { useTranslation } from 'react-i18next'
import logos from '@percent/cause-dashboard/common/assets/images/logos.png'
import { useAuthState, useCausesPortalAnalytics, useSitewideMessage } from '@percent/cause-dashboard/common/hooks'
import { SignUpEventName } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/causeDashboardAnalytics.types'
import { Typography } from '@percent/lemonade'

export function ClaimPage() {
  const { t } = useTranslation()

  const { track } = useCausesPortalAnalytics()
  const { authState } = useAuthState()
  const [claimResults, setClaimResults] = useState({
    selectedCharityCountryCode: defaultCountryCode,
    selectedCharityName: ''
  })

  const handleSearchClick = (countryCode: string, query: string) => {
    setClaimResults({
      selectedCharityCountryCode: countryCode,
      selectedCharityName: query
    })

    track(SignUpEventName.SEARCH_FOR_NONPROFIT, {
      organisationName: query,
      accountId: authState.user?.id
    })
  }

  const { shouldShowSitewideMessage } = useSitewideMessage()
  const shiftDownToAccomodateRebrandNotification = shouldShowSitewideMessage ? 48 : 0
  const minHeightToAccomodateRebrandNotification = shouldShowSitewideMessage ? 'calc(100vh - 48px)' : '100vh'

  return (
    <div
      className={styles.pageContainer}
      style={{
        marginTop: shiftDownToAccomodateRebrandNotification,
        minHeight: minHeightToAccomodateRebrandNotification
      }}
    >
      <NavigationBar />
      <div className={styles.heroContainer}>
        <div className={styles.hero}>
          <Typography color={'secondary'} className={styles.heroAnnotation}>
            {t('typography.heroAnnotation')}
          </Typography>
          <Typography variant="h3" color="secondary" className={styles.heroTitle}>
            {t('typography.heroTitle')}
          </Typography>
          <Typography color="secondary" className={styles.heroDescription}>
            {t('typography.heroDescription')}
          </Typography>
        </div>
        <img className={styles.heroLogos} alt="logos-landing-page" src={logos} />
      </div>
      <div className={styles.searchAndFooterContainer}>
        <div className={styles.searchAndFooterInnerContainer}>
          <ClaimSearchHeader onSearchClick={handleSearchClick} />
          <ClaimSearchResults claimResults={claimResults} />
          <Footer />
        </div>
      </div>
    </div>
  )
}
